import { configureStore } from '@reduxjs/toolkit'
import commonReducer from '@redux/common.js'
import registrationReducer from '@redux/registration.js'
import updateReducer from '@redux/update.js'

const store = configureStore({
  reducer: {
    common: commonReducer,
    registrationDetails: registrationReducer,
    update: updateReducer,
  },
})

export default store

